export { GlobalTheme, GlobalStyles } from './global-styles'
